const round = (num: number, type: 'up' | 'down') => {
	if (10000 > num)
		return type === 'up'
			? Math.ceil(num).toLocaleString()
			: Math.floor(num).toLocaleString();

	if (num >= 10000 && 1000000 > num)
		return type === 'up'
			? Math.ceil(num / 1000) / 10 + '만'
			: Math.floor(num / 1000) / 10 + '만';

	if (num >= 1000000 && 100000000 > num)
		return type === 'up'
			? Math.ceil(num / 10000).toLocaleString() + '만'
			: Math.floor(num / 10000).toLocaleString() + '만';

	if (num >= 100000000 && 10000000000 > num)
		return type === 'up'
			? Math.ceil(num / 10000000) / 10 + '억'
			: Math.floor(num / 10000000) / 10 + '억';

	if (num >= 10000000000)
		return type === 'up'
			? Math.ceil(num / 100000000).toLocaleString() + '억'
			: Math.floor(num / 100000000).toLocaleString() + '억';

	return null;
};

export const roundFloat = (num: number, type: 'up' | 'down', fixed: number) => {
	const fixed_num = +`1${new Array(fixed).fill('0').join('')}`;

	if (type === 'up') return Math.ceil(num * fixed_num) / fixed_num;
	else return Math.floor(num * fixed_num) / fixed_num;
};

export const floatFixed = (value: number | string, fixed: number) => {
	const num = typeof value === 'string' ? value : value.toString();

	return parseFloat(num).toFixed(fixed);
};

export default round;
